import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form } from 'semantic-ui-react'

import SeguroPermite from '../../../components/funcionales/seguropermite'

import XLSX from 'xlsx'
import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries'
var moment = require('moment');

//dropdown EMPRESAS
const DetalleEmpNivel1 = props => {
  // console.log(props.elemento)
  return (
    <option style={props.styles.input}>{props.elemento.descrEmpresa}</option>
  )
};

const ListaEmp = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleEmpNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrEmpresa" id="miLista" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar Empresa...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown EMPRESAS

//Lista de mecanismos
const DetallePl = ({elemento, indice, handleChange}) => {
  return(
    <tr className=''>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>
        <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' name="checkSeleccInf" checked={elemento.checkSeleccInf} onChange={(ev)=>handleChange(ev, indice)}/>
      </td>      
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrPlanta}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrSeccion}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEquipo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrComponente}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMecanismo}</td>
    </tr>
  )
};
const ListaPl = ({list, handleChange}) => {
  // console.log(list)
    const nivel1Detalle = list.map((elemento, i) => <DetallePl elemento={elemento} key={i} indice={i}
      handleChange={handleChange}/>);
    return(
      <tbody className=''>
        {nivel1Detalle}
      </tbody>
    )
  };

//FIN Lista de mecanismos

class LabInfGer2 extends React.Component {
  state={list: 
    this.props.allInflabRtes1.allInflabRtes?this.props.allInflabRtes1.allInflabRtes.map((elemento, i) => ({
      ...elemento, checkSeleccInf: true
    })):[], 
  argsDocum: {descrEmpresa: "Seleccionar Empresa...", desde: this.props.fechaHoy, hasta: this.props.fechaFin},
      permiteUpdate: true, confirmaAct: false, open: false, argsBuscInf: {}, checkSeleccInfAll: true,
      argsQuery: `{$group: {_id: {descrEmpresa: '$descrEmpresa', descrPlanta: '$descrPlanta', 
      descrSeccion: '$descrSeccion', descrEquipo: '$descrEquipo', descrComponente: '$descrComponente', 
      descrMecanismo: '$descrMecanismo', tipoFrecuencia: '$tipoFrecuencia'}}},
        {$sort: {'_id.descrEmpresa': 1, '_id.descrPlanta': 1, '_id.descrSeccion': 1, '_id.descrEquipo': 1, 
        '_id.descrComponente': 1, '_id.descrMecanismo': 1}},
        {$project: {_id: {$concat: ['$_id.descrEmpresa', '$_id.descrPlanta', '$_id.descrSeccion', 
        '$_id.descrEquipo', '$_id.descrComponente', '$_id.descrMecanismo']}, 
        descrEmpresa: '$_id.descrEmpresa', descrPlanta: '$_id.descrPlanta', descrSeccion: '$_id.descrSeccion', 
        descrEquipo: '$_id.descrEquipo', descrComponente: '$_id.descrComponente', 
        descrMecanismo: '$_id.descrMecanismo', tipoFrecuencia: '$_id.tipoFrecuencia'}}`
}

  crudBD = async (operacionCRUD, args, i)=>{
    if(args.ctrlCampo === 'CRUD'){
      const {data} = await operacionCRUD({
        variables: args
      });

//Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        const {data} = await operacionCRUD({
          variables: args
        });
      }
    }
  }

  updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }else{
      await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }
    for(let i=1; i<totDocCRUD; i++){
      await this.crudBD(crudColecc[i], argsCrud[i], i)
    }
  }

  handleChange = async (ev, indice) => {
    if(ev.target.name === "checkSeleccInfAll"){
      const list = this.state.list
      let checkSeleccInfAll = this.state.checkSeleccInfAll
      console.log(checkSeleccInfAll)
      if(checkSeleccInfAll){
        checkSeleccInfAll = false
      }else{
        checkSeleccInfAll = true
      }
      for(let i=0; i<list.length; i++){
        list[i].checkSeleccInf = checkSeleccInfAll
        console.log(list[i].checkSeleccInf)
      }
      this.setState({checkSeleccInfAll});
      this.setState({list});
    }

    if(ev.target.name === "checkSeleccInf"){
      const list = this.state.list
      let checkSeleccInfAll = this.state.checkSeleccInfAll
      list[indice].checkSeleccInf = ev.target.checked
      checkSeleccInfAll = false
      this.setState({checkSeleccInfAll});
      this.setState({list});
    }    

    if(ev.target.name==="descrEmpresa"||ev.target.name==="desde"||ev.target.name==="hasta"){
      const argsDocum = this.state.argsDocum
      argsDocum[ev.target.name] = ev.target.value
      let argsBuscar=""
      if(ev.target.name==="descrEmpresa"){
        argsBuscar += `'descrEmpresa': '${ev.target.value}'`
      }else{
        argsBuscar += `'descrEmpresa': '${argsDocum.descrEmpresa}'`
      }
      if(this.props.argsBuscInf.descrPlanta){
        argsBuscar += `, 'descrPlanta': /${this.props.argsBuscInf.descrPlanta}/i`
      }
      if(this.props.argsBuscInf.descrSeccion){
        argsBuscar += `, 'descrSeccion': /${this.props.argsBuscInf.descrSeccion}/i`
      }
      if(this.props.argsBuscInf.descrEquipo){
        argsBuscar += `, 'descrEquipo': /${this.props.argsBuscInf.descrEquipo}/i`
      }
      if(this.props.argsBuscInf.descrComponente){
        argsBuscar += `, 'descrComponente': /${this.props.argsBuscInf.descrComponente}/i`
      }
      if(this.props.argsBuscInf.descrMecanismo){
        argsBuscar += `, 'descrMecanismo': /${this.props.argsBuscInf.descrMecanismo}/i`
      }

      let argsBuscarF = ""
      if(ev.target.name==="descrEmpresa"){
        argsBuscarF = `${argsBuscar}, fechaMuestra: { $gte: '${argsDocum.desde}', $lte: '${argsDocum.hasta}' }`
      }else{
        if(ev.target.name==="desde"){
          argsBuscarF = `${argsBuscar}, fechaMuestra: { $gte: '${ev.target.value}', $lte: '${argsDocum.hasta}' }`
        }else{
          argsBuscarF = `${argsBuscar}, fechaMuestra: { $gte: '${argsDocum.desde}', $lte: '${ev.target.value}' }`
        }
      }
      let argsBuscarPl = {tipoqry: `[{$match: {'estadoInflab': 'FINALIZADO', ${argsBuscarF}}}, ${this.state.argsQuery}]`}
      
      await this.props.allInflabRtes1.refetch(argsBuscarPl)
      if(this.props.allInflabRtes1.allInflabRtes){
        this.setState({list: 
          this.props.allInflabRtes1.allInflabRtes?this.props.allInflabRtes1.allInflabRtes.map((elemento, i) => ({
            ...elemento, checkSeleccInf: true
          })):[]
        })
        this.setState({checkSeleccInfAll: true});
      }
        // argsDocum[ev.target.name] = ev.target.value
      this.setState({argsDocum});
      // }
    }
  }

  handleSubmit = async (ev, list1, argsDocum)=>{
    document.body.style.cursor = 'wait'

    if(list1.length>0){
      let list2 = await list1.filter(elemento => elemento.checkSeleccInf === true)

      let numeroDia = new Date(argsDocum.desde).getDay() + 1 
      let diasdif= new Date(argsDocum.hasta).getTime()-new Date(argsDocum.desde).getTime()
      let contdias = Math.round(diasdif/(1000*60*60*24))
      
      // console.log(numeroDia, contdias)
      let semanas = []
      let semanas1 = [] 
      let pruebas = []
      let pruebas1 = []
      let numLineas=2
      let numLineas2=6
      let numColumnas=10
      let logo=''
      let acumDias = 7-numeroDia

      for (let i=0;i<this.props.allEmpresa.allEmpresa.length;i++){
        let empresas=this.props.allEmpresa.allEmpresa[i]
        if(empresas.descrEmpresa===argsDocum.descrEmpresa){
          if(empresas.logo!==null && empresas.logo!==''){
            // logo="C:\\slcm\\logos\\" + empresas.logo
            logo="https://montserratslcm.com/images/logos/" + empresas.logo
          }  
        }
      }  

      let rutaLogo=this.props.rutaLogo
      let macro=this.props.versionMacroUA

      let campoAgno = ''
      let campoMes = ''
      let campoDia= ''
      let fechaFin = new Date()
      fechaFin = new Date(argsDocum.desde).getTime() + (1000*60*60*24)*(acumDias)
      fechaFin = new Date(fechaFin)
      fechaFin = (fechaFin.getFullYear()) + '-' + ((fechaFin.getMonth()+1)<10?'0'+(fechaFin.getMonth()+1):(fechaFin.getMonth()+1)) + '-' + (fechaFin.getUTCDate()<10?'0'+fechaFin.getUTCDate():fechaFin.getUTCDate())
      campoAgno = fechaFin.substring(0, 4)
      campoMes = fechaFin.substring(5, 7)
      campoDia = fechaFin.substring(8, 10)
      let fecha2 = campoAgno + '-' + campoMes + '-' + campoDia
      campoAgno = argsDocum.desde.substring(0, 4)
      campoMes = argsDocum.desde.substring(5, 7)
      campoDia = argsDocum.desde.substring(8, 10)
      let fechaSemana = campoAgno + '-' + campoMes + '-' + campoDia + ' a ' + fecha2
      semanas1 = [{inicio:1, fin:8-numeroDia, semana:1, fecha:fechaSemana}]
      semanas.push(semanas1)
      let contSemana = 2
      if(contdias>7-numeroDia){
        for(let i=9-numeroDia; i<contdias; i+=7){

          let fechaIni = new Date()
          acumDias += 1
          fechaIni = new Date(argsDocum.desde).getTime() + (1000*60*60*24)*(acumDias)

          fechaIni = new Date(fechaIni)
          fechaIni = (fechaIni.getFullYear()) + '-' + ((fechaIni.getMonth()+1)<10?'0'+(fechaIni.getMonth()+1):(fechaIni.getMonth()+1)) + '-' + (fechaIni.getUTCDate()<10?'0'+fechaIni.getUTCDate():fechaIni.getUTCDate())
          campoAgno = fechaIni.substring(0, 4)
          campoMes = fechaIni.substring(5, 7)
          campoDia = fechaIni.substring(8, 10)
          let fecha1 = campoAgno + '-' + campoMes + '-' + campoDia
          
          acumDias += 6
          fechaFin = new Date(argsDocum.desde).getTime() + (1000*60*60*24)*(acumDias)
          fechaFin = new Date(fechaFin)
          fechaFin = (fechaFin.getFullYear()) + '-' + ((fechaFin.getMonth()+1)<10?'0'+(fechaFin.getMonth()+1):(fechaFin.getMonth()+1)) + '-' + (fechaFin.getUTCDate()<10?'0'+fechaFin.getUTCDate():fechaFin.getUTCDate())
          campoAgno = fechaFin.substring(0, 4)
          campoMes = fechaFin.substring(5, 7)
          campoDia = fechaFin.substring(8, 10)
          let fecha2 = campoAgno + '-' + campoMes + '-' + campoDia

          let fechaSemana = fecha1 + ' a ' + fecha2

          semanas1 = [{inicio:i, fin:i+6, semana:contSemana, fecha:fechaSemana}]
          semanas.push(semanas1)
          contSemana+=1
        }
      }
      contSemana -= 1
      numColumnas+=contSemana
      numLineas+=list2.length
 
      let xlsString = []
      let xlsString1 = []
      let argsCeldas=""
      let xlsString2 = []
      let xlsString21 = []
      let argsCeldas2=""
      let xlsString3 = []
      let xlsString31 = []
      let argsCeldas3=""
      let xlsString4 = []
      let xlsString41 = []

      let argsCeldas41 = rutaLogo
      let argsCeldas42 = logo
      let argsCeldas43=macro
      xlsString41.push(argsCeldas41)
      xlsString41.push(argsCeldas42)
      xlsString41.push(argsCeldas43)
      xlsString4.push(xlsString41)
      xlsString41 = []
      argsCeldas41="Estados de equipos"
      argsCeldas42=""
      argsCeldas43=""
      xlsString41.push(argsCeldas41)
      xlsString41.push(argsCeldas42)
      xlsString41.push(argsCeldas43)
      xlsString4.push(xlsString41)
      xlsString41 = []
      argsCeldas41="Confiable"
      argsCeldas42=0
      argsCeldas43=0
      xlsString41.push(argsCeldas41)
      xlsString41.push(argsCeldas42)
      xlsString41.push(argsCeldas43)
      xlsString4.push(xlsString41)
      xlsString41 = []
      argsCeldas41="Alarma/Precaución"
      argsCeldas42=0
      argsCeldas43=0
      xlsString41.push(argsCeldas41)
      xlsString41.push(argsCeldas42)
      xlsString41.push(argsCeldas43)
      xlsString4.push(xlsString41)
      xlsString41 = []
      argsCeldas41="Peligro"
      argsCeldas42=0
      argsCeldas43=0
      xlsString41.push(argsCeldas41)
      xlsString41.push(argsCeldas42)
      xlsString41.push(argsCeldas43)
      xlsString4.push(xlsString41)
      xlsString41 = []
      argsCeldas41="Estados de mecanismos"
      argsCeldas42=""
      argsCeldas43=""
      xlsString41.push(argsCeldas41)
      xlsString41.push(argsCeldas42)
      xlsString41.push(argsCeldas43)
      xlsString4.push(xlsString41)
      xlsString41 = []
      argsCeldas41="Confiable"
      argsCeldas42=0
      argsCeldas43=0
      xlsString41.push(argsCeldas41)
      xlsString41.push(argsCeldas42)
      xlsString41.push(argsCeldas43)
      xlsString4.push(xlsString41)
      xlsString41 = []
      argsCeldas41="Alarma/Precaución"
      argsCeldas42=0
      argsCeldas43=0
      xlsString41.push(argsCeldas41)
      xlsString41.push(argsCeldas42)
      xlsString41.push(argsCeldas43)
      xlsString4.push(xlsString41)
      xlsString41 = []
      argsCeldas41="Peligro"
      argsCeldas42=0
      argsCeldas43=0
      xlsString41.push(argsCeldas41)
      xlsString41.push(argsCeldas42)
      xlsString41.push(argsCeldas43)
      xlsString4.push(xlsString41)
      xlsString41 = []
      argsCeldas41="Tipo de problema"
      argsCeldas42=""
      argsCeldas43=""
      xlsString41.push(argsCeldas41)
      xlsString41.push(argsCeldas42)
      xlsString41.push(argsCeldas43)
      xlsString4.push(xlsString41)
      xlsString41 = []
      argsCeldas41="Aceites"
      argsCeldas42=0
      argsCeldas43=0
      xlsString41.push(argsCeldas41)
      xlsString41.push(argsCeldas42)
      xlsString41.push(argsCeldas43)
      xlsString4.push(xlsString41)
      xlsString41 = []
      argsCeldas41="Mecanismo"
      argsCeldas42=0
      argsCeldas43=0
      xlsString41.push(argsCeldas41)
      xlsString41.push(argsCeldas42)
      xlsString41.push(argsCeldas43)
      xlsString4.push(xlsString41)
      xlsString41 = []

      for (let i=0;i<numColumnas;i++){
        if(i===0){
          argsCeldas = rutaLogo
        }else{
          if(i===1){
            argsCeldas = logo
          }else{
            if(i===2){
              argsCeldas = macro
            }else{  
              if(i===5){
                argsCeldas = 'INFORME GERENCIAL DE ANALISIS DE LABORATORIO DE ACEITES'
              }else{
                argsCeldas = ''
              }
            }
          }
        }
        xlsString1.push(argsCeldas)
      }
      xlsString.push(xlsString1)
      xlsString1 = []

      for (let i=0;i<90;i++){
        if(i===0){
          argsCeldas2 = rutaLogo
          argsCeldas3 = rutaLogo
        }else{
          if(i===1){
            argsCeldas2 = macro
            argsCeldas3 = macro
          }else{
            if(i===3){
              argsCeldas2 = 'INFORME GERENCIAL DE ANALISIS DE LABORATORIO DE ACEITES'
              argsCeldas3 = 'INFORME GERENCIAL DE ANALISIS DE LABORATORIO DE ACEITES'
            }else{
              if(i===8){
                argsCeldas2 = ''
                argsCeldas3 = logo
              }else{
                if(i===36){
                  argsCeldas2 = logo
                  argsCeldas3 = ''
                }else{
                  argsCeldas2=''
                  argsCeldas3=''
                }          
              }
            }
          }
        }
        xlsString21.push(argsCeldas2)
        xlsString31.push(argsCeldas3)
      }
      
      xlsString2.push(xlsString21)
      xlsString21 = []
      xlsString3.push(xlsString31)
      xlsString31 = []

      for (let i=0;i<contSemana+7;i++){
        if(i===0){
          argsCeldas = 'Empresa'
        }else{
          if(i===1){
            argsCeldas = argsDocum.descrEmpresa
          }else{
            if(i===2){
              argsCeldas = numLineas
            }else{
              if(i===3){
                argsCeldas = numColumnas
              }else{
                if(i===9){
                  argsCeldas = `Programación desde  ${argsDocum.desde} hasta ${argsDocum.hasta}`;
                }else{
                  argsCeldas = ''
                }
              }
            }
          }
        }
        xlsString1.push(argsCeldas)
      }
      
      xlsString.push(xlsString1)
      xlsString1 = []

      for (let i=0;i<90;i++){
        if(i===0){
          argsCeldas2 = 'Empresa'
        }else{
          if(i===1){
            argsCeldas2 = argsDocum.descrEmpresa
          }else{
            if(i===2){
              argsCeldas2 = ''
            }else{
              if(i===13){
                argsCeldas2 = `Resultados de la ultima toma de muestra`
              }else{
                argsCeldas2 = ''
              }
            }
          }
        }
        xlsString21.push(argsCeldas2)
      }
      
      xlsString2.push(xlsString21)
      xlsString21 = []

      for (let i=0;i<90;i++){
        if(i===0){
          argsCeldas3 = 'Empresa'
        }else{
          if(i===1){
            argsCeldas3 = argsDocum.descrEmpresa
          }else{
            if(i===2){
              argsCeldas3 = numLineas
            }else{
              if(i===8){
                argsCeldas3 = 'Análisis y Recomendaciones del último informe'
              }else{
                argsCeldas3 = ''
              }          
            }          
          }
        }
        xlsString31.push(argsCeldas3)
      }
      
      xlsString3.push(xlsString31)
      xlsString31 = []
// console.log(contSemana)
      for (let i=0;i<contSemana+10;i++){
        if(i===0){
          argsCeldas = 'Estado'
        }
        if(i===1){
          argsCeldas = 'Tipo frecuencia'
        }
        if(i===2){
          argsCeldas = 'Planta'
        }
        if(i===3){
          argsCeldas = 'Sección'
        }
        if(i===4){
          argsCeldas = 'Equipo'
        }
        if(i===5){
          argsCeldas = 'Cod. Equipo'
        }
        if(i===6){
          argsCeldas = 'Componente'
        }
        if(i===7){
          argsCeldas = 'Mecanismo'
        }
        // if(i===6){
        //   argsCeldas = 'Estado'
        // }
        if(i===8){
          argsCeldas = 'Recorrido del aceite'
        }
        if(i===9){
          argsCeldas = 'Recorrido promedio del uso del aceite'
        }
        if(i>9){
          let numSemana=i-9
          let colSemana=''


          let indexDias = -1
          semanas.forEach(async (elemento, ii) => {
            if(parseInt(numSemana)===parseInt(semanas[ii][0].semana)){
              indexDias = ii
            }
          })
          if (indexDias!==-1){
            colSemana=semanas[indexDias][0].fecha
          } 

          argsCeldas = colSemana
        }
        xlsString1.push(argsCeldas)
      }
      xlsString.push(xlsString1)

      for (let i=0;i<90;i++){
        if(i===0){
          argsCeldas2 = 'No. Informe'
        }
        if(i===1){
          argsCeldas2 = 'Estado'
        }
        if(i===2){
          argsCeldas2 = 'Tipo frecuencia'
        }
        if(i===3){
          argsCeldas2 = 'Planta'
        }
        if(i===4){
          argsCeldas2 = 'Sección'
        }
        if(i===5){
          argsCeldas2 = 'Equipo'
        }
        if(i===6){
          argsCeldas2 = 'Cod. Equipo'
        }
        if(i===7){
          argsCeldas2 = 'Componente'
        }
        if(i===8){
          argsCeldas2 = 'Mecanismo'
        }
        if(i===9){
          argsCeldas2 = 'Lubricante'
        }
        if(i===10){
          argsCeldas2 = 'Volumen total aceite'
        }
        if(i===11){
          argsCeldas2 = 'Fecha de la toma de muestra del aceite'
        }
        if(i===12){
          argsCeldas2 = '(km/hora/fecha) de la toma de muestra del aceite'
        }
        if(i===13){
          argsCeldas2 = '(km/hora/fecha) último cambio de aceite'
        }
        if(i===14){
          argsCeldas2 = 'Recorrido del aceite'
        }
        if(i===15){
          argsCeldas2 = 'Fecha envío a laboratorio'
        }
        if(i===16){
          argsCeldas2 = 'Fecha recibe laboratorio'
        }
        if(i===17){
          argsCeldas2 = 'Fecha envío a cliente'
        }        
        if(i===18){
          argsCeldas2 = 'Tiempo de análisis de la muestra (Días)'
        }
        if(i===19){
          argsCeldas2 = 'Tiempo de ejecución de la muestra (Días)'
        }
        if(i===20){
          argsCeldas2 = 'PROPIEDADES FISICO/QUIMICAS'
        }
        if(i===25){
          argsCeldas2 = 'CONTAMINACION'
        }
        if(i===34){
          argsCeldas2 = 'INFRA-ROJO (abs / mm)'
        }
        if(i===40){
          argsCeldas2 = 'DESGASTE DE METALES(ppm)'
        }
        if(i===48){
          argsCeldas2 = 'CONTAMINANTES EXTERNOS, ppm (mg/kg)'
        }
        if(i===52){
          argsCeldas2 = 'ADITIVOS DEL ACEITE, ppm (mg/kg)'
        }
        if(i===60){
          argsCeldas2 = 'PRUEBAS ESPECIALES'
        }
        if(i>20 && i!==25 && i!==34 && i!==40 && i!==48 && i!==52 && i!==60){
          argsCeldas2 = ''
        }
        xlsString21.push(argsCeldas2)
      }
      xlsString2.push(xlsString21)
      xlsString21 = []


      for (let i=0;i<15;i++){
        if(i===0){
          argsCeldas3 = 'No. Informe'
        }
        if(i===1){
          argsCeldas3 = 'Estado'
        }
        if(i===2){
          argsCeldas3 = 'Tipo frecuencia'
        }
        if(i===3){
          argsCeldas3 = 'Planta'
        }
        if(i===4){
          argsCeldas3 = 'Sección'
        }
        if(i===5){
          argsCeldas3 = 'Equipo'
        }
        if(i===6){
          argsCeldas3 = 'Cod. Equipo'
        }
        if(i===7){
          argsCeldas3 = 'Componente'
        }
        if(i===8){
          argsCeldas3 = 'Mecanismo'
        }
        if(i===9){
          argsCeldas3 = 'Fecha de la toma de muestra del aceite'
        }
        if(i===10){
          argsCeldas3 = '(km/hora/fecha) de la toma de muestra del aceite'
        }
        if(i===11){
          argsCeldas3 = 'Recorrido del aceite'
        }
        if(i===12){
          argsCeldas3 = 'Análisis'
        }
        if(i===13){
          argsCeldas3 = 'Recomendaciones'
        }
        if(i===14){
          argsCeldas3 = 'Estado (1=Ejec. / 0=Pend.)'
        }
        xlsString31.push(argsCeldas3)
      }
      xlsString3.push(xlsString31)

      let filaAc=14
      let filaMec=62
      for (let i=0;i<97;i++){
        if(i===20){
          argsCeldas2 = 'Viscosidad, cSt a 40ºC'
          pruebas1 = [{prueba:'Viscosidad, cSt a 40ºC', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)
          filaAc+=1
        }
        if(i===21){ 
          argsCeldas2 = 'Viscosidad, cSt a 100ºC'
          pruebas1 = [{prueba:'Viscosidad, cSt a 100ºC', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }
        if(i===22){
          argsCeldas2 = 'Índice de Viscosidad IV'
          pruebas1 = [{prueba:'Índice de Viscosidad IV', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }
        if(i===23){
          argsCeldas2 = 'TAN'
          pruebas1 = [{prueba:'TAN', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }
        if(i===24){
          argsCeldas2 = 'TBN'
          pruebas1 = [{prueba:'TBN', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }
        if(i===25){
          argsCeldas2 = 'Agua'
          pruebas1 = [{prueba:'Agua', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }
        if(i===26){
          argsCeldas2 = 'Código de partículas'
          pruebas1 = [{prueba:'Código de partículas', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }
        if(i===27){
          argsCeldas2 = 'Partículas > 4 micras'
          pruebas1 = [{prueba:'Partículas > 4 micras', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }
        if(i===28){
          argsCeldas2 = 'Partículas > 6 micras'
          pruebas1 = [{prueba:'Partículas > 6 micras', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }
        if(i===29){
          argsCeldas2 = 'Partículas > 14 micras'
          pruebas1 = [{prueba:'Partículas > 14 micras', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }
        if(i===30){
          argsCeldas2 = 'Partículas > 21 micras'
          pruebas1 = [{prueba:'Partículas > 21 micras', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }
        if(i===31){
          argsCeldas2 = 'Partículas > 25 micras'
          pruebas1 = [{prueba:'Partículas > 25 micras', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }
        if(i===32){
          argsCeldas2 = 'Partículas > 38 micras'
          pruebas1 = [{prueba:'Partículas > 38 micras', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }
        if(i===33){
          argsCeldas2 = 'Partículas > 70 micras'
          pruebas1 = [{prueba:'Partículas > 70 micras', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }
        if(i===34){
          argsCeldas2 = 'Hollín'
          pruebas1 = [{prueba:'Hollín', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }
        if(i===35){
          argsCeldas2 = 'Nitración'
          pruebas1 = [{prueba:'Nitración', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }
        if(i===36){
          argsCeldas2 = 'Sulfatación'
          pruebas1 = [{prueba:'Sulfatación', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }
        if(i===37){
          argsCeldas2 = 'Dilución por Combustible'
          pruebas1 = [{prueba:'Dilución por Combustible', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }
        if(i===38){
          argsCeldas2 = 'Glicol'
          pruebas1 = [{prueba:'Glicol', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }
        if(i===39){
          argsCeldas2 = 'Oxidación'
          pruebas1 = [{prueba:'Oxidación', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }      
        if(i===40){
          argsCeldas2 = 'Hierro (Fe)'
          pruebas1 = [{prueba:'Hierro (Fe)', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }
        if(i===41){
          argsCeldas2 = 'Cobre (Cu)'
          pruebas1 = [{prueba:'Cobre (Cu)', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }
        if(i===42){
          argsCeldas2 = 'Aluminio (Al)'
          pruebas1 = [{prueba:'Aluminio (Al)', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }
        if(i===43){
          argsCeldas2 = 'Cromo (Cr)'
          pruebas1 = [{prueba:'Cromo (Cr)', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }
        if(i===44){
          argsCeldas2 = 'Plomo (Pb)'
          pruebas1 = [{prueba:'Plomo (Pb)', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }
        if(i===45){
          argsCeldas2 = 'Estaño (Sn)'
          pruebas1 = [{prueba:'Estaño (Sn)', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }
        if(i===46){
          argsCeldas2 = 'Níquel (Ni)'
          pruebas1 = [{prueba:'Níquel (Ni)', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }
        if(i===47){
          argsCeldas2 = 'Titanio (Ti)'
          pruebas1 = [{prueba:'Titanio (Ti)', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }
        if(i===48){
          argsCeldas2 = 'Vanadio (V)'
          pruebas1 = [{prueba:'Vanadio (V)', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }
        if(i===49){
          argsCeldas2 = 'Silicio (Si)'
          pruebas1 = [{prueba:'Silicio (Si)', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }
        if(i===50){
          argsCeldas2 = 'Sodio (Na)'
          pruebas1 = [{prueba:'Sodio (Na)', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }
        if(i===51){
          argsCeldas2 = 'Potasio (K)'
          pruebas1 = [{prueba:'Potasio (K)', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }
        if(i===52){
          argsCeldas2 = 'Boro (B)'
          pruebas1 = [{prueba:'Boro (B)', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }
        if(i===53){
          argsCeldas2 = 'Magnesio (Mg)'
          pruebas1 = [{prueba:'Magnesio (Mg)', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }
        if(i===54){
          argsCeldas2 = 'Calcio (Ca)'
          pruebas1 = [{prueba:'Calcio (Ca)', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }
        if(i===55){
          argsCeldas2 = 'Fósforo (P)'
          pruebas1 = [{prueba:'Fósforo (P)', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }
        if(i===56){
          argsCeldas2 = 'Zinc (Zn)'
          pruebas1 = [{prueba:'Zinc (Zn)', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }
        if(i===57){
          argsCeldas2 = 'Molibdeno (Mo)'
          pruebas1 = [{prueba:'Molibdeno (Mo)', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }
        if(i===58){
          argsCeldas2 = 'Bario (Ba)'
          pruebas1 = [{prueba:'Bario (Ba)', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }
        if(i===59){
          argsCeldas2 = 'Manganeso (Mn)'
          pruebas1 = [{prueba:'Manganeso (Mn)', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===60){
          argsCeldas2 = 'Color'
          pruebas1 = [{prueba:'Color', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===61){
          argsCeldas2 = 'Ruler %'
          pruebas1 = [{prueba:'Ruler %', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===62){
          argsCeldas2 = 'Ruler Aminas'
          pruebas1 = [{prueba:'Ruler Aminas', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===63){
          argsCeldas2 = 'Ruler Fenoles'
          pruebas1 = [{prueba:'Ruler Fenoles', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===64){
          argsCeldas2 = 'Ruler ZDDP'
          pruebas1 = [{prueba:'Ruler ZDDP', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===65){
          argsCeldas2 = 'Prueba de oxidación de recipientes a presión giratorios RPVOT'
          pruebas1 = [{prueba:'Prueba de oxidación de recipientes a presión giratorios RPVOT', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===66){
          argsCeldas2 = 'Barnices Potencial (MPC)'
          pruebas1 = [{prueba:'Barnices Potencial (MPC)', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }  
        if(i===67){
          argsCeldas2 = 'Demulsibilidad Aceite'
          pruebas1 = [{prueba:'Demulsibilidad Aceite', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===68){
          argsCeldas2 = 'Demulsibilidad Agua'
          pruebas1 = [{prueba:'Demulsibilidad Agua', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===69){
          argsCeldas2 = 'Demulsibilidad Emulsión'
          pruebas1 = [{prueba:'Demulsibilidad Emulsión', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===70){
          argsCeldas2 = 'Demulsibilidad Tiempo'
          pruebas1 = [{prueba:'Demulsibilidad Tiempo', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===71){
          argsCeldas2 = 'Separabilidad Aceite a 54ºC'
          pruebas1 = [{prueba:'Separabilidad Aceite a 54ºC', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===72){
          argsCeldas2 = 'Separabilidad Agua a 54ºC'
          pruebas1 = [{prueba:'Separabilidad Agua a 54ºC', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===73){
          argsCeldas2 = 'Separabilidad Emulsión a 54ºC'
          pruebas1 = [{prueba:'Separabilidad Emulsión a 54ºC', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===74){
          argsCeldas2 = 'Separabilidad Tiempo a 54ºC'
          pruebas1 = [{prueba:'Separabilidad Tiempo a 54ºC', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===75){
          argsCeldas2 = 'Separabilidad Aceite a 82ºC'
          pruebas1 = [{prueba:'Separabilidad Aceite a 82ºC', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===76){
          argsCeldas2 = 'Separabilidad Agua a 82ºC'
          pruebas1 = [{prueba:'Separabilidad Agua a 82ºC', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===77){
          argsCeldas2 = 'Separabilidad Emulsión a 82ºC'
          pruebas1 = [{prueba:'Separabilidad Emulsión a 82ºC', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===78){
          argsCeldas2 = 'Separabilidad Tiempo a 82ºC'
          pruebas1 = [{prueba:'Separabilidad Tiempo a 82ºC', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===79){
          argsCeldas2 = 'Espumas Secuencia I (0.0 min) Tendencia'
          pruebas1 = [{prueba:'Espumas Secuencia I (0.0 min) Tendencia', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===80){
          argsCeldas2 = 'Espumas Secuencia I (10 min) Estabilidad'
          pruebas1 = [{prueba:'Espumas Secuencia I (10 min) Estabilidad', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===81){
          argsCeldas2 = 'Espumas Secuencia II (0.0 min) Tendencia'
          pruebas1 = [{prueba:'Espumas Secuencia II (0.0 min) Tendencia', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===82){
          argsCeldas2 = 'Espumas Secuencia II (10 min) Estabilidad'
          pruebas1 = [{prueba:'Espumas Secuencia II (10 min) Estabilidad', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===83){
          argsCeldas2 = 'Espumas Secuencia III (0.0 min) Tendencia'
          pruebas1 = [{prueba:'Espumas Secuencia III (0.0 min) Tendencia', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===84){
          argsCeldas2 = 'Espumas Secuencia III (10 min) Estabilidad'
          pruebas1 = [{prueba:'Espumas Secuencia III (10 min) Estabilidad', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===85){
          argsCeldas2 = 'Liberación de aire'
          pruebas1 = [{prueba:'Liberación de aire', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===86){
          argsCeldas2 = 'Punto de inflamación'
          pruebas1 = [{prueba:'Punto de inflamación', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===87){
          argsCeldas2 = 'Corrosión en lamina de cobre'
          pruebas1 = [{prueba:'Corrosión en lamina de cobre', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===88){
          argsCeldas2 = 'Ultracentrifuga'
          pruebas1 = [{prueba:'Ultracentrifuga', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }         
        if(i===89){
          argsCeldas2 = 'Densidad a 15°C'
          pruebas1 = [{prueba:'Densidad a 15°C', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }
        if(i===90){
          argsCeldas2 = 'Apariencia'
          pruebas1 = [{prueba:'Apariencia', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }  
        if(i===91){
          argsCeldas2 = 'Olor'
          pruebas1 = [{prueba:'Olor', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }         
        if(i===92){
          argsCeldas2 = 'Punto de fuego'
          pruebas1 = [{prueba:'Punto de fuego', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }
        if(i===93){
          argsCeldas2 = 'Indice PQ'
          pruebas1 = [{prueba:'Indice PQ', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }
        if(i===94){
          argsCeldas2 = 'Agua por Karl Fischer'
          pruebas1 = [{prueba:'Agua por Karl Fischer', columna:i+1, tipo:'Mecanismo', fila:filaMec}]
          pruebas.push(pruebas1)        
          filaMec+=1
        }
        if(i===95){
          argsCeldas2 = 'TAN con PTE'
          pruebas1 = [{prueba:'TAN con PTE', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }
        if(i===96){
          argsCeldas2 = 'TBN con PTE'
          pruebas1 = [{prueba:'TBN con PTE', columna:i+1, tipo:'Aceites', fila:filaAc}]
          pruebas.push(pruebas1)        
          filaAc+=1
        }
        if(i<20){
          argsCeldas2 = ''
        }
        xlsString21.push(argsCeldas2)
      }
      xlsString2.push(xlsString21)
      xlsString21 = []

      argsCeldas41="Causas de alarma y peligro asociadas al aceite"
      argsCeldas42=""
      argsCeldas43=""
      xlsString41.push(argsCeldas41)
      xlsString41.push(argsCeldas42)
      xlsString41.push(argsCeldas43)
      xlsString4.push(xlsString41)
      xlsString41 = []

      pruebas.forEach(async (elemento, iii) => {
        if(pruebas[iii][0].tipo==='Aceites'){
          argsCeldas41=pruebas[iii][0].prueba
          argsCeldas42=0
          argsCeldas43=0
          xlsString41.push(argsCeldas41)
          xlsString41.push(argsCeldas42)
          xlsString41.push(argsCeldas43)
          xlsString4.push(xlsString41)
          xlsString41 = []
        }
      })
      argsCeldas41="Causas de alarma y peligro asociadas al mecanismo"
      argsCeldas42=""
      argsCeldas43=""
      xlsString41.push(argsCeldas41)
      xlsString41.push(argsCeldas42)
      xlsString41.push(argsCeldas43)
      xlsString4.push(xlsString41)
      xlsString41 = []
      pruebas.forEach(async (elemento, iii) => {
        if(pruebas[iii][0].tipo==='Mecanismo'){
          argsCeldas41=pruebas[iii][0].prueba
          argsCeldas42=0
          argsCeldas43=0
          xlsString41.push(argsCeldas41)
          xlsString41.push(argsCeldas42)
          xlsString41.push(argsCeldas43)
          xlsString4.push(xlsString41)
          xlsString41 = []
        }
      })
// console.log(xlsString4)
      argsCeldas41="Clasificación de los estados de alarma y peligro"
      argsCeldas42=""
      argsCeldas43=""
      xlsString41.push(argsCeldas41)
      xlsString41.push(argsCeldas42)
      xlsString41.push(argsCeldas43)
      xlsString4.push(xlsString41)
      xlsString41 = []

      argsCeldas41='Propiedades físico'
      argsCeldas42=0
      argsCeldas43=0
      xlsString41.push(argsCeldas41)
      xlsString41.push(argsCeldas42)
      xlsString41.push(argsCeldas43)
      xlsString4.push(xlsString41)
      xlsString41 = []

      argsCeldas41='Propiedades químicas'
      argsCeldas42=0
      argsCeldas43=0
      xlsString41.push(argsCeldas41)
      xlsString41.push(argsCeldas42)
      xlsString41.push(argsCeldas43)
      xlsString4.push(xlsString41)
      xlsString41 = []

      argsCeldas41='Contaminación'
      argsCeldas42=0
      argsCeldas43=0
      xlsString41.push(argsCeldas41)
      xlsString41.push(argsCeldas42)
      xlsString41.push(argsCeldas43)
      xlsString4.push(xlsString41)
      xlsString41 = []

      argsCeldas41='Infra-rojo (abs / mm)'
      argsCeldas42=0
      argsCeldas43=0
      xlsString41.push(argsCeldas41)
      xlsString41.push(argsCeldas42)
      xlsString41.push(argsCeldas43)
      xlsString4.push(xlsString41)
      xlsString41 = []

      argsCeldas41='Desgaste de metales(ppm)'
      argsCeldas42=0
      argsCeldas43=0
      xlsString41.push(argsCeldas41)
      xlsString41.push(argsCeldas42)
      xlsString41.push(argsCeldas43)
      xlsString4.push(xlsString41)
      xlsString41 = []

      argsCeldas41='Contaminantes externos, ppm (mg/kg)'
      argsCeldas42=0
      argsCeldas43=0
      xlsString41.push(argsCeldas41)
      xlsString41.push(argsCeldas42)
      xlsString41.push(argsCeldas43)
      xlsString4.push(xlsString41)
      xlsString41 = []

      argsCeldas41='Aditivos del aceite, ppm (mg/kg)'
      argsCeldas42=0
      argsCeldas43=0
      xlsString41.push(argsCeldas41)
      xlsString41.push(argsCeldas42)
      xlsString41.push(argsCeldas43)
      xlsString4.push(xlsString41)
      xlsString41 = []

      argsCeldas41='Pruebas especiales'
      argsCeldas42=0
      argsCeldas43=0
      xlsString41.push(argsCeldas41)
      xlsString41.push(argsCeldas42)
      xlsString41.push(argsCeldas43)
      xlsString4.push(xlsString41)
      xlsString41 = []

      for (let i=0;i<97;i++){
        if(i<20){
          argsCeldas2 = ''
        }else{
          if(i<60){
            if(i===20 || i===21){
              argsCeldas2 = 'cSt'
            }else{
              if(i===22){
                argsCeldas2 = 'Adimensional'
              }else{
                if(i===23 || i===24){
                  argsCeldas2 = 'mgKOH/g'
                }else{
                  if(i===25){
                    argsCeldas2 = '% por volumen'
                  }else{
                    if(i===26){
                      argsCeldas2 = 'Código'
                    }else{
                      if(i>26 && i<34){
                        argsCeldas2 = 'Partículas/100 mL'
                      }else{
                        if(i===34){
                          argsCeldas2 = '%wt'
                        }else{
                          if(i===35 || i===36 || i===39){
                            argsCeldas2 = 'abs/mm2'
                          }else{
                            if(i===38){
                              argsCeldas2 = '%'
                            }else{
                              argsCeldas2 = 'ppm'
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }else{
            if(i===60 || i===86 || i===88){
              argsCeldas2 = 'Numérico'
            }else{
              if(i===87){
                argsCeldas2 = 'Alfanumérico'
              }else{
                if(i===65 || i===70 || i===74 || i===78 || i===85){
                  argsCeldas2 = 'min'
                }else{
                  if(i===66){
                    argsCeldas2 = 'ΔE'
                  }else{
                    if(i===61 || i===62 || i===63 || i===64){
                      argsCeldas2 = '%'
                    }else{
                      if(i===89){
                        argsCeldas2 = 'g/cm3'
                      }else{
                        if(i===92){
                          argsCeldas2 = 'ºC'
                        }else{
                          if(i===90 || i===91){
                            argsCeldas2 = ''
                          }else{
                            if(i===93){
                              argsCeldas2 = 'Adimensional'
                            }else{
                              if(i===95 || i===96){
                                argsCeldas2 = 'mgKOH/g'
                              }else{
                                if(i===94){
                                  argsCeldas2 = '% por volumen'
                                }else{
                                  argsCeldas2 = 'ml'
                                }                               
                              }                            
                            }                          
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }      
        
        xlsString21.push(argsCeldas2)
      }
      xlsString2.push(xlsString21)
      xlsString21 = []

      for (let i=0;i<97;i++){
        if(i<60){
          if(i<20){
            argsCeldas2 = ''
          }else{
            if(i===20 || i===21){
              argsCeldas2 = 'ASTMD 445'
            }else{
              if(i===22){
                argsCeldas2 = 'ASTMD 2270'
              }else{
                if(i===25 || i===34 || i===35 || i===36 || i===37 || i===39){
                  argsCeldas2 = 'ASTM E2412'
                }else{
                  if(i===38){
                    argsCeldas2 = 'ASTMD 2413'
                  }else{
                    if(i>25 && i<34){
                      argsCeldas2 = 'ISO 4406'
                    }else{
                      if(i===23){
                        argsCeldas2 = 'ASTM D 664'
                      }else{
                        if(i===24){
                          argsCeldas2 = 'ASTM D 2896'
                        }else{
                          argsCeldas2 = 'ASTMD 6595'
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }else{
          if(i===60){
            argsCeldas2 = 'ASTM D 1500'
          }else{
            if(i===61 || i===62 || i===63 || i===64){
              argsCeldas2 = 'ASTM D 6971'
            }else{
              if(i===65){
                argsCeldas2 = 'ASTM D 2272'
              }else{
                if(i===66){
                  argsCeldas2 = 'ASTM D 7843'
                }else{
                  if(i===67 || i===68 || i===69 || i===70 || i===90){
                    argsCeldas2 = 'ASTM D1401'
                  }else{
                    if(i===79 || i===80 || i===81 || i===82 || i===83 || i===84){
                      argsCeldas2 = 'ASTM D 892'
                    }else{
                      if(i===85){
                        argsCeldas2 = 'ASTM D 3427'
                      }else{
                        if(i===86 || i===92){
                          argsCeldas2 = 'ASTM D92'
                        }else{
                          if(i===87){
                            argsCeldas2 = 'ASTM D 130'
                          }else{
                            if(i===89){
                              argsCeldas2 = 'ASTM D4052'
                            }else{
                              if(i===91){
                                argsCeldas2 = ''
                              }else{
                                if(i===93){
                                  argsCeldas2 = 'ASTM D8184'
                                }else{
                                  if(i===94){
                                    argsCeldas2 = 'ASTM D6304'
                                  }else{
                                    if(i===95){
                                      argsCeldas2 = 'ASTM D664'
                                    }else{
                                      if(i===96){
                                        argsCeldas2 = 'ASTM D2896'
                                      }else{
                                        if(i>70 && i<79){
                                          argsCeldas2 = 'ASTM D 1401-21'
                                        }else{
                                          argsCeldas2 = 'ASTM D1796'
                                        }
                                      }                                 
                                    }                               
                                  }                              
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        xlsString21.push(argsCeldas2)
      }
      xlsString2.push(xlsString21)
    

    
      let cadenaEq=''
      let cadenaEqAnt=''
      let cadenaMec=''
      let cadenaMecAnt=''
      let confiableEq=0
      let confiableEq1=0
      let alarmaEq=0
      let alarmaEq1=0
      let peligroEq=0
      let peligroEq1=0
      let confiableMec=0
      let confiableMec1=0
      let alarmaMec=0
      let alarmaMec1=0
      let peligroMec=0
      let peligroMec1=0
      let cuentaC=0
      let cuentaA=0
      let cuentaP=0
      let cuentaMC=0
      let cuentaMA=0
      let cuentaMP=0
      let cuentaReg=0
      let cuentaAceites=0
      let cuentaMecanismo=0
      let contEq=1
      let contMec=1

      for (let i=0;i<list2.length;i++){
        
        xlsString1 = []
        xlsString21 = []
        xlsString31 = []
        let argsBuscar=""
        argsBuscar += `'descrEmpresa': '${list2[i].descrEmpresa}'`
        argsBuscar += `, 'descrPlanta': '${list2[i].descrPlanta}'`
        argsBuscar += `, 'descrSeccion': '${list2[i].descrSeccion}'`
        argsBuscar += `, 'descrEquipo': '${list2[i].descrEquipo}'`
        argsBuscar += `, 'descrComponente': '${list2[i].descrComponente}'`
        argsBuscar += `, 'descrMecanismo': '${list2[i].descrMecanismo}'`
        let argsBuscarF = ""
      // if(ev.target.name==="descrEmpresa"){
        argsBuscarF = `${argsBuscar}, fechaMuestra: { $gte: '${argsDocum.desde}', $lte: '${argsDocum.hasta}' }`
      // }else{
      //   if(ev.target.name==="desde"){
      //     argsBuscarF = `${argsBuscar}, fechaMuestra: { $gte: '${ev.target.value}', $lte: '${argsDocum.hasta}' }`
      //   }else{
      //     argsBuscarF = `${argsBuscar}, fechaMuestra: { $gte: '${argsDocum.desde}', $lte: '${ev.target.value}' }`
      //   }
      // }        
        for (let ii=0;ii<numColumnas;ii++){

          if(ii===1){
            argsCeldas = list2[i].tipoFrecuencia
          }
          if(ii===2){
            argsCeldas = list2[i].descrPlanta
            argsCeldas2 = list2[i].tipoFrecuencia
          }
          if(ii===3){
            argsCeldas = list2[i].descrSeccion
            argsCeldas2 = list2[i].descrPlanta
          }
          if(ii===4){
            argsCeldas = list2[i].descrEquipo
            argsCeldas2 = list2[i].descrSeccion
          }
          if(ii===5){
            argsCeldas = list2[i].codEquipo
            argsCeldas2 = list2[i].descrEquipo
          }
          if(ii===6){
            argsCeldas = list2[i].descrComponente
            argsCeldas2 = list2[i].codEquipo
          }
          if(ii===7){
            argsCeldas = list2[i].descrMecanismo
            argsCeldas2 = list2[i].descrComponente
          }
          if(ii===8){
            argsCeldas2 = list2[i].descrMecanismo
          }
          if(ii>7){
            argsCeldas = ''
          }
          if(ii>8){
            argsCeldas2 = ''
          }
          xlsString1.push(argsCeldas)
          // xlsString21.push(argsCeldas2)
          xlsString31.push(argsCeldas2)
        }      
      
        let listInf = []
        let argsBuscarPl = {tipoqry: `[{$match: {'estadoInflab': 'FINALIZADO', ${argsBuscarF}}},
                            {$sort: {'fechaMuestra': 1}}]`}
console.log(argsBuscarPl)
        let {data} = await this.props.allInflabRtes1.refetch(argsBuscarPl)
        listInf = await data.allInflabRtes

        if(listInf.length>0){
          let contPru=0
          let sumRec=0
          
          await listInf.forEach(async (elemento, ii) => {
            contPru+=1
            cadenaEq=list2[i].descrPlanta + list2[i].descrSeccion + list2[i].descrEquipo
            cadenaMec=list2[i].descrPlanta + list2[i].descrSeccion + list2[i].descrEquipo + list2[i].descrComponente + list2[i].descrMecanismo
            xlsString21 = []
            if(elemento.fechaMuestra){
              numLineas2+=1
              let dateString1 = elemento.fechaMuestra 
              let dateString2 = argsDocum.desde
              let dateParts1 = dateString1.split("-")
              let dateParts2 = dateString2.split("-")

              let dateObject1 = new Date(+dateParts1[0], dateParts1[1] - 1, +dateParts1[2])
              let dateObject2 = new Date(+dateParts2[0], dateParts2[1] - 1, +dateParts2[2]) 

              let fecha1 = new Date(dateObject1).getTime()
              let fecha2 = new Date(dateObject2).getTime()
              
              let contDias = parseInt((fecha1 - fecha2) / (1000*60*60*24), 10)
              let indexDias = -1
              semanas.forEach(async (elemento1, ii) => {
                if(parseInt(contDias)>=parseInt(semanas[ii][0].inicio) && parseInt(contDias)<=parseInt(semanas[ii][0].fin)){
                  indexDias = ii
                }
              })
              let numSem=-1
              if (indexDias!==-1){
                numSem=semanas[indexDias][0].semana
              }              
              if (numSem!==-1){
                let fecEnvio = '', fecRecibe = '', fecCliente = ''
                if(elemento.fechaEnvioLab){
                  let fecha1 = moment(elemento.fechaEnvioLab).format('YYYY-MM-DD')
                  fecEnvio = fecha1
                }
                if(elemento.fechaRecibeLab){
                  let fecha2 = moment(elemento.fechaRecibeLab).format('YYYY-MM-DD')
                  fecRecibe = fecha2
                }
                if(elemento.fechaEnvioCliente){
                  let fecha3 = moment(elemento.fechaEnvioCliente).format('YYYY-MM-DD')
                  fecCliente = fecha3
                }

                xlsString1[numSem+9]='Inf: ' + elemento.numeroInflab + '_' + elemento.mecInflab + '  Fecha prueba: ' + elemento.fechaMuestra + ' - Toma de muestra: ' + elemento.tomaMuestra + ' - Último cambio: ' + elemento.ultimoCambio + ' - Recorrido: ' + elemento.recorrido + ' - Enviada a laboratorio: ' + fecEnvio + ' - Recibe laboratorio: ' + fecRecibe + ' - Enviada a cliente: ' + fecCliente + '          ' + elemento.estado
                cuentaReg+=1
                // console.log(cuentaReg, cadenaMec, elemento.fechaMuestra, elemento.estado, numSem)
              }else{
                // console.log('OJOOOO', elemento.fechaMuestra, elemento.estado)
              }              
              if(elemento.estado){
                xlsString1[0]=elemento.estado
                xlsString31[1]=elemento.estado
              }
              if(elemento.observaciones){
                xlsString31[12]=elemento.observaciones
              }
              if(elemento.acciones){
                xlsString31[13]=elemento.acciones

                let parrafo =elemento.acciones.split("\n")
                parrafo.forEach((acc, jj) => {   
                  if(acc){
                    if(jj===0){
                      xlsString31[14]=0
                    }else{
                      xlsString31[14]+="\n" + 0
                    }
                  }
                })
              }
              xlsString31[0]=elemento.numeroInflab + '_' + elemento.mecInflab

              if(elemento.recorrido!==null && elemento.recorrido!==''){
                xlsString1[8]=elemento.recorrido
                sumRec+=elemento.recorrido
                xlsString1[9]=parseInt(sumRec/contPru)
              }else{
                xlsString1[8]=''
              }



              for (let ii=0;ii<90;ii++){
                if(ii===0){
                  argsCeldas2=elemento.numeroInflab + '_' + elemento.mecInflab
                }
                if(ii===1){
                  argsCeldas2=elemento.estado?elemento.estado:''
                }
                if(ii===2){
                  argsCeldas2 = elemento.tipoFrecuencia
                }
                if(ii===3){
                  argsCeldas2 = elemento.descrPlanta
                }
                if(ii===4){
                  argsCeldas2 = elemento.descrSeccion
                }
                if(ii===5){
                  argsCeldas2 = elemento.descrEquipo
                }
                if(ii===6){
                  argsCeldas2 = elemento.codEquipo
                }
                if(ii===7){
                  argsCeldas2 = elemento.descrComponente
                }
                if(ii===8){
                  argsCeldas2 = elemento.descrMecanismo
                }
                if(ii===9){
                  argsCeldas2 = elemento.descrLubricante
                }
                if(ii===10){
                  argsCeldas2 = elemento.aceiteTotal?elemento.aceiteTotal:''
                }
                if(ii===11){
                  argsCeldas2 = elemento.fechaMuestra
                }
                if(ii===12){
                  argsCeldas2 = elemento.tomaMuestra?elemento.tomaMuestra:''
                }
                if(ii===13){
                  argsCeldas2 = elemento.ultimoCambio?elemento.ultimoCambio:''
                }
                if(ii===14){
                  argsCeldas2 = elemento.recorrido?elemento.recorrido:''
                }
                if(ii===15){
                  let fecEnvio = ''
                  if(elemento.fechaEnvioLab){
                    let fecha1 = moment(elemento.fechaEnvioLab).format('YYYY-MM-DD')
                    fecEnvio = fecha1
                  }
                  argsCeldas2=fecEnvio              
                }
                if(ii===16){
                  let fecRecibe = ''
                  if(elemento.fechaRecibeLab){
                    let fecha2 = moment(elemento.fechaRecibeLab).format('YYYY-MM-DD')
                    fecRecibe = fecha2
                  }
                  argsCeldas2=fecRecibe
                }
                if(ii===17){
                  let fecCliente = ''
                  if(elemento.fechaEnvioCliente){
                    let fecha3 = moment(elemento.fechaEnvioCliente).format('YYYY-MM-DD')
                    fecCliente = fecha3
                  }                 
                   argsCeldas2 = fecCliente
                }
                if(ii===18){
                  if(elemento.fechaMuestra && elemento.fechaRecibeLab){
                    let fecha1 = new Date(elemento.fechaRecibeLab)
                    fecha1 = (fecha1.getFullYear()) + '-' + ((fecha1.getMonth()+1)<10?'0'+(fecha1.getMonth()+1):(fecha1.getMonth()+1)) + '-' + (fecha1.getUTCDate()<10?'0'+fecha1.getUTCDate():fecha1.getUTCDate())
                    fecha1=moment(fecha1)
                    let fecha2=new Date(elemento.fechaMuestra)
                    let numDias= fecha1.diff(fecha2, 'days')
                    argsCeldas2=numDias
                  }else{
                    argsCeldas2=''
                  }
                }
                if(ii===19){
                  if(elemento.fechaEnvioCliente && elemento.fechaRecibeLab){
                    let fecha1 = new Date(elemento.fechaEnvioCliente)
                    fecha1 = (fecha1.getFullYear()) + '-' + ((fecha1.getMonth()+1)<10?'0'+(fecha1.getMonth()+1):(fecha1.getMonth()+1)) + '-' + (fecha1.getUTCDate()<10?'0'+fecha1.getUTCDate():fecha1.getUTCDate())
                    fecha1=moment(fecha1)
                    let fecha2 = new Date(elemento.fechaRecibeLab)
                    fecha2 = (fecha2.getFullYear()) + '-' + ((fecha2.getMonth()+1)<10?'0'+(fecha2.getMonth()+1):(fecha2.getMonth()+1)) + '-' + (fecha2.getUTCDate()<10?'0'+fecha2.getUTCDate():fecha2.getUTCDate())
                    fecha2=moment(fecha2)
                    let numDias= fecha1.diff(fecha2, 'days')
                    argsCeldas2=numDias
                  }else{
                    argsCeldas2=''
                  }
                }
                if(ii>19){
                  let indexNom = -1
                  pruebas.forEach(async (elemento, iii) => {
                    if(parseInt(ii+1)===parseInt(pruebas[iii][0].columna) ){
                      indexNom = iii
                    }
                  })
                  if (indexNom !==-1){
                    let nomPru = pruebas[indexNom][0].prueba
                    let indexPru = elemento.reportes.findIndex( pruLab => pruLab.columna2===nomPru || pruLab.columna1===nomPru )
                    if(indexPru!==-1){
                      if(elemento.reportes[indexPru].columna25==='Pruebas especiales'){
                        argsCeldas2=elemento.reportes[indexPru].columna13 + '                         ' + elemento.reportes[indexPru].columna30
                      }else{
                        if(elemento.numeroInflab>2155 || elemento.numeroInflab===2060){
                          argsCeldas2=elemento.reportes[indexPru].columna11 + '                         ' + elemento.reportes[indexPru].columna30
                        }else{
                          argsCeldas2=elemento.reportes[indexPru].columna12 + '                         ' + elemento.reportes[indexPru].columna30
                        }
                      }
                    }else{
                      argsCeldas2=""
                    }
                  }else{
                    argsCeldas2=""
                  }
                }
                xlsString21.push(argsCeldas2)
              }
              xlsString2.push(xlsString21)

              if(listInf.length===contPru){
                
                if((cadenaEq===cadenaEqAnt) || ((cadenaEq!==cadenaEqAnt) && (cadenaEqAnt===''))){
                  if(elemento.estado==='CONFIABLE'){
                    cuentaC += 1
                    if(i===list2.length-1){
                      confiableEq += 1
                    }
                  }else{
                    if(elemento.estado==='ALARMA' || elemento.estado==='PRECAUCION'){
                      cuentaA += 1
                      if(i===list2.length-1){
                        alarmaEq += 1
                      }
                    }else{
                      if(elemento.estado==='PELIGRO'){
                        cuentaP += 1
                        if(i===list2.length-1){
                          peligroEq += 1
                        }
                      }
                    }
                  }
                }else{
                  if(cadenaEqAnt!==''){
                    contEq += 1
                    if(parseInt(cuentaP)>0){
                      peligroEq += 1
                    }else{
                      if(parseInt(cuentaA)>0){
                        alarmaEq += 1
                      }else{
                        if(parseInt(cuentaC)>0){
                          confiableEq += 1
                        }
                      }
                    }
                  }
                  cuentaC=0
                  cuentaA=0
                  cuentaP=0

                  if(elemento.estado==='CONFIABLE'){
                    cuentaC += 1
                    if(i===list2.length-1){
                      confiableEq += 1
                    }
                  }else{
                    if(elemento.estado==='ALARMA' || elemento.estado==='PRECAUCION'){
                      cuentaA += 1
                      if(i===list2.length-1){
                        alarmaEq += 1
                      }
                    }else{
                      if(elemento.estado==='PELIGRO'){
                        cuentaP += 1
                        if(i===list2.length-1){
                          peligroEq += 1
                        }
                      }
                    }
                  }
                }
    
                if((cadenaMec===cadenaMecAnt) || ((cadenaMec!==cadenaMecAnt) && (cadenaMecAnt===''))){
                  if(elemento.estado==='CONFIABLE'){
                    cuentaMC += 1
                  }else{
                    if(elemento.estado==='ALARMA' || elemento.estado==='PRECAUCION'){
                      cuentaMA += 1
                    }else{
                      if(elemento.estado==='PELIGRO'){
                        cuentaMP += 1
                      }
                    }
                  }
                }else{
                  if(cadenaMecAnt!==''){
                    contMec += 1
                    if(parseInt(cuentaMP)>0){
                      peligroMec += 1
                    }else{
                      if(parseInt(cuentaMA)>0){
                        alarmaMec += 1
                      }else{
                        if(parseInt(cuentaMC)>0){
                          confiableMec += 1
                        }
                      }
                    }
                  }
                  cuentaMC=0
                  cuentaMA=0
                  cuentaMP=0
                  if(elemento.estado==='CONFIABLE'){
                    cuentaMC += 1
                    if(i===list2.length-1){
                      confiableMec += 1
                    }
                  }else{
                    if(elemento.estado==='ALARMA' || elemento.estado==='PRECAUCION'){
                      cuentaMA += 1
                      if(i===list2.length-1){
                        alarmaMec += 1
                      }
                    }else{
                      if(elemento.estado==='PELIGRO'){
                        cuentaMP += 1
                        if(i===list2.length-1){
                          peligroMec += 1
                        }
                      }
                    }
                  }
                }
              }
            }

            // if(listInf[ii].mecInflab===7691){
            //   console.log(listInf, listInf.length, contPru)
            // }



            if(listInf.length===contPru){
              listInf[ii].reportes.forEach((pruebaSel, i) => {
                if(pruebaSel.columna30==='ALARMA' || pruebaSel.columna30==='PELIGRO' || pruebaSel.columna30==='PRECAUCION'){  
                  pruebas.forEach(async (elemento, iii) => {
                    if(pruebaSel.columna2===pruebas[iii][0].prueba || pruebaSel.columna1===pruebas[iii][0].prueba){
                      if(pruebas[iii][0].tipo==='Aceites'){
                        cuentaAceites+=1
                        
                        if(pruebaSel.columna2==='Viscosidad, cSt a 40ºC'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Viscosidad, cSt a 100ºC'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Índice de Viscosidad IV'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='TAN'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='TBN'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Oxidación'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Boro (B)'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Magnesio (Mg)'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Calcio (Ca)'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Fósforo (P)'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Zinc (Zn)'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Molibdeno (Mo)'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Bario (Ba)'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Manganeso (Mn)'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Color'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Ruler %'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Ruler Aminas'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Ruler Fenoles'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Ruler ZDDP'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Prueba de oxidación de recipientes a presión giratorios RPVOT'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Demulsibilidad Aceite'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Demulsibilidad Agua'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Demulsibilidad Emulsión'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Demulsibilidad Tiempo'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Separabilidad Aceite a 54ºC'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Separabilidad Agua a 54ºC'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Separabilidad Emulsión a 54ºC'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Separabilidad Tiempo a 54ºC'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Separabilidad Aceite a 82ºC'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Separabilidad Agua a 82ºC'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Separabilidad Emulsión a 82ºC'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Separabilidad Tiempo a 82ºC'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Espumas Secuencia I (0.0 min) Tendencia'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Espumas Secuencia I (10 min) Estabilidad'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Espumas Secuencia II (0.0 min) Tendencia'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Espumas Secuencia II (10 min) Estabilidad'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Espumas Secuencia III (0.0 min) Tendencia'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Espumas Secuencia III (10 min) Estabilidad'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Liberación de aire'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Punto de inflamación'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Corrosión en lamina de cobre'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Densidad a 15°C'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        } 
                        if(pruebaSel.columna1==='Apariencia'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Olor'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Punto de fuego'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Indice PQ'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='TAN con PTE'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='TBN con PTE'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        } 
                      }else{
                        cuentaMecanismo+=1
                        if(pruebaSel.columna2==='Agua'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Código de partículas'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Partículas > 4 micras'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Partículas > 6 micras'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Partículas > 14 micras'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Partículas > 21 micras'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Partículas > 25 micras'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Partículas > 38 micras'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Partículas > 70 micras'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Hollín'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Nitración'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Sulfatación'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Dilución por Combustible'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Glicol'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Hierro (Fe)'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Cobre (Cu)'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Aluminio (Al)'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Cromo (Cr)'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Plomo (Pb)'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Estaño (Sn)'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Níquel (Ni)'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Titanio (Ti)'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Vanadio (V)'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Silicio (Si)'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Sodio (Na)'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna2==='Potasio (K)'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Barnices Potencial (MPC)'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }                    
                        if(pruebaSel.columna1==='Ultracentrifuga'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                        if(pruebaSel.columna1==='Agua por Karl Fischer'){
                          xlsString4[pruebas[iii][0].fila][1]=xlsString4[pruebas[iii][0].fila][1] + 1
                        }
                      }
                      if(pruebaSel.columna1==='PROPIEDADES FISICO'){
                        xlsString4[92][1]=xlsString4[92][1] + 1
                      }
                      if(pruebaSel.columna1==='PROPIEDADES QUIMICAS'){
                        xlsString4[93][1]=xlsString4[93][1] + 1
                      }
                      if(pruebaSel.columna1==='CONTAMINACION'){
                        xlsString4[94][1]=xlsString4[94][1] + 1
                      }
                      if(pruebaSel.columna1==='INFRA-ROJO (abs / mm)'){
                        xlsString4[95][1]=xlsString4[95][1] + 1
                      }
                      if(pruebaSel.columna1==='DESGASTE DE METALES(ppm)'){
                        xlsString4[96][1]=xlsString4[96][1] + 1
                      }
                      if(pruebaSel.columna1==='CONTAMINANTES EXTERNOS, ppm (mg/kg)'){
                        xlsString4[97][1]=xlsString4[97][1] + 1
                      }
                      if(pruebaSel.columna1==='ADITIVOS DEL ACEITE, ppm (mg/kg)'){
                        // console.log(listInf[ii].mecInflab, pruebaSel.columna1, pruebaSel.columna2, pruebaSel.columna30)
                        xlsString4[98][1]=xlsString4[98][1] + 1
                        // console.log(xlsString4[98][1])
                      }
                      if(pruebaSel.columna25==='PRUEBAS ESPECIALES' || pruebaSel.columna25==='Pruebas especiales'){
                        xlsString4[99][1]=xlsString4[99][1] + 1
                      }                    
                    }
                  })
                }  
              });
          
              if(elemento.fechaMuestra){
                xlsString31[9]=elemento.fechaMuestra
              }
              if(elemento.tomaMuestra){
                xlsString31[10]=elemento.tomaMuestra
              }
              if(elemento.recorrido){
                xlsString31[11]=elemento.recorrido
              }
            }
          })
        }
        xlsString.push(xlsString1)
        xlsString3.push(xlsString31)
        
        cadenaEqAnt=cadenaEq
        cadenaMecAnt=cadenaMec
      }

      xlsString2[1][2]=numLineas2

      if(contEq===1){
        if(parseInt(cuentaP)>0){
          peligroEq += 1
        }else{
          if(parseInt(cuentaA)>0){
            alarmaEq += 1
          }else{
            if(parseInt(cuentaC)>0){
              confiableEq += 1
            }
          }
        }
      }
      if(contMec===1){
        if(parseInt(cuentaMP)>0){
          peligroMec += 1
        }else{
          if(parseInt(cuentaMA)>0){
            alarmaMec += 1
          }else{
            if(parseInt(cuentaMC)>0){
              confiableMec += 1
            }
          }
        }
      }
      xlsString4[2][1]=confiableEq
      xlsString4[3][1]=alarmaEq
      xlsString4[4][1]=peligroEq
      xlsString4[6][1]=confiableMec
      xlsString4[7][1]=alarmaMec
      xlsString4[8][1]=peligroMec
      xlsString4[10][1]=cuentaAceites
      xlsString4[11][1]=cuentaMecanismo

      var wb = XLSX.utils.book_new();

      wb.Props = {
        Title: "SheetJS Tutorial",
        Subject: "Test",
        Author: "Red Stapler",
        CreatedDate: new Date(2017,12,19)
      };

      wb.SheetNames.push("Informe_Pruebas");
      wb.SheetNames.push("Informes");
      wb.SheetNames.push("Recomendaciones");
      wb.SheetNames.push("Indicadores");

      let ws_data = xlsString;
      let ws_data2 = xlsString2;
      let ws_data3 = xlsString3;
      let ws_data4 = xlsString4;

      let ws = XLSX.utils.aoa_to_sheet(ws_data);
      let ws2 = XLSX.utils.aoa_to_sheet(ws_data2);
      let ws3 = XLSX.utils.aoa_to_sheet(ws_data3);
      let ws4 = XLSX.utils.aoa_to_sheet(ws_data4);
      
      wb.Sheets["Informe_Pruebas"] = ws;
      wb.Sheets["Informes"] = ws2;
      wb.Sheets["Recomendaciones"] = ws3;
      wb.Sheets["Indicadores"] = ws4;

      let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
      function s2ab(s) { 
        let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
        let view = new Uint8Array(buf);  //create uint8array as viewer
        for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
        return buf;    
      }
      saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'Informe_Pruebas_Lab_'+argsDocum.descrEmpresa+'.xlsx');
// //FIN Exportar a XLS

      document.body.style.cursor = 'default'
    }

  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  async componentDidUpdate(prevProps){
    if(this.props.argsBuscInf!==this.state.argsBuscInf){
      let argsBuscar=""
      argsBuscar += `'descrEmpresa': '${this.state.argsDocum.descrEmpresa}'`
      if(this.props.argsBuscInf.descrPlanta){
        argsBuscar += `, 'descrPlanta': /${this.props.argsBuscInf.descrPlanta}/i`
      }
      if(this.props.argsBuscInf.descrSeccion){
        argsBuscar += `, 'descrSeccion': /${this.props.argsBuscInf.descrSeccion}/i`
      }
      if(this.props.argsBuscInf.descrEquipo){
        argsBuscar += `, 'descrEquipo': /${this.props.argsBuscInf.descrEquipo}/i`
      }
      if(this.props.argsBuscInf.descrComponente){
        argsBuscar += `, 'descrComponente': /${this.props.argsBuscInf.descrComponente}/i`
      }
      if(this.props.argsBuscInf.descrMecanismo){
        argsBuscar += `, 'descrMecanismo': /${this.props.argsBuscInf.descrMecanismo}/i`
      }
      argsBuscar += `, fechaMuestra: { $gte: '${this.state.argsDocum.desde}', $lte: '${this.state.argsDocum.hasta}' }`
      
      let argsBuscarPl = {tipoqry: `[{$match: {'estadoInflab': 'FINALIZADO', ${argsBuscar}}}, ${this.state.argsQuery}]`}

      await this.props.allInflabRtes1.refetch(argsBuscarPl)

//Cuando se usa await para que no ejecute de la siguiente linea en adelante se debe usar el resultado del await
//por eso el if de la siguiente linea
      if(this.props.allInflabRtes1.allInflabRtes){
        this.setState({argsBuscInf: this.props.argsBuscInf})
        if(this.props.allInflabRtes1.allInflabRtes&&prevProps.allInflabRtes1.allInflabRtes){
          if((this.props.allInflabRtes1.allInflabRtes!==prevProps.allInflabRtes1.allInflabRtes)||!this.state.list){
            this.setState({list: 
              this.props.allInflabRtes1.allInflabRtes?this.props.allInflabRtes1.allInflabRtes.map((elemento, i) => ({
                ...elemento, checkSeleccInf: true
              })):[]
            })
            this.setState({checkSeleccInfAll: true});
          }
        }
      }
      // this.setState({argsDocum});
      // this.setState({argsBuscInf: this.props.argsBuscInf})
    }
  }

  render(){
    const {list, argsDocum, permiteUpdate, checkSeleccInfAll, confirmaAct, open} = this.state;
    // const a250110 = autorizacUA.findIndex( autorizac => autorizac === "250110" );
    let mensaje = "GENERAR INFORME"
    let imgIcon = "images/documento_32.png"
    
    let  list2 = []
    if(this.props.allEmpresa.allEmpresa){list2 = this.props.allEmpresa.allEmpresa}
    return (
      // <div>
        <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, list, argsDocum):()=>{}}>
            <div className="ui two column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '30%', paddingLeft: '1.2em'}}>
                  <Form.Field>
                    <ListaEmp styles={this.props.styles} list={list2} handleChange={this.handleChange} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: '20%'}}>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Desde
                  </p>
                  <Form.Field>
                    <input style={this.props.styles.input} type='date' name="desde" id="desde" value={argsDocum.desde} onChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: '20%'}}>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Hasta
                  </p>
                  <Form.Field>
                    <input style={this.props.styles.input} type='date' name="hasta" id="hasta" value={argsDocum.hasta} onChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: '30%', paddingTop: '0.1em'}}>
                  <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                </div>
              </div>
            </div>
            <div>
              <div style={{height: '36em', overflow: 'auto'}}>
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      {/* <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Fecha</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '3%'}}>Inf</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '3%'}}>Rte</th> */}
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>
                        <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' name="checkSeleccInfAll" checked={checkSeleccInfAll} onChange={this.handleChange}/>
                      </th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '20%'}}>Planta</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '20%'}}>Sección</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '20%'}}>Equipo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '20%'}}>Componente</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '20%'}}>Mecanismo</th>
                      {/* <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '13%'}}>Lubricante</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Estado</th> */}
                    </tr>
                  </thead>
                  <ListaPl list={list} handleChange={this.handleChange}/>
                </table>
                <p></p>
              </div>
            </div>
          </Form>
        </div>
      // </div>
    )
  }
};

export default compose(
  graphql(queries.query.allInflabRtes, {name:'allInflabRtes1',
    options: (props) => {return {variables: {tipoqry: `[{$match: {'numeroInflab': {$lt: 0}}}]`}}}}),

  // graphql(queries.query.allInflabRtes, {name:'allInflabRtes2',
  //   options: (props) => {return {variables: {tipoqry: `[{$match: {'numeroInflab': {$lt: 0}}}]`}}}}),
    
  graphql(queries.query.allEmpresa, {name:'allEmpresa'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),

  )(LabInfGer2)
